module.exports = __webpack_public_path__ + "img/MNP.ccebb68f.svg";